<template>
  <vf-input
    v-bind="$props"
    v-model="modelValue"
    data-test-id="input-password"
    :label="label || $t.password"
    required
    :type="showPassword ? 'text' : 'password'"
    @change="$emit('change', $event)"
  >
    <template #after>
      <slot name="after">
        <base-button
          :aria-label="$t.showPassword"
          :aria-pressed="showPassword"
          class="flex center"
          @click="showPassword = !showPassword"
        >
          <vf-icon :name="showPassword ? 'visible' : 'hidden'" size="md" />
        </base-button>
      </slot>
    </template>
  </vf-input>
</template>

<script lang="ts" setup>
import type { Props } from '#brands/components/vf/input/Input.vue'

defineProps<Omit<Props, 'inputmode' | 'max' | 'min' | 'name' | 'propsLabel' | 'propsInput' | 'type'> & { label?: string }>()

defineEmits<{ change: [value: string] }>()

defineSlots<{
  after?: () => void
}>()

const modelValue = defineModel<string | number>()

const showPassword = ref(false)
</script>
